"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consents = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class Consents extends base_models_1.Serializable {
}
exports.Consents = Consents;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ description: 'Customer accepted callback', example: true }),
    tslib_1.__metadata("design:type", Boolean)
], Consents.prototype, "acceptedCallFromAdvisor", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ description: 'Customer accepted payment conditions', example: true }),
    tslib_1.__metadata("design:type", Boolean)
], Consents.prototype, "acceptedPaymentConditions", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ description: 'Customer accepted terms and conditions', example: true }),
    tslib_1.__metadata("design:type", Boolean)
], Consents.prototype, "acceptedTermsAndConditions", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ description: 'Customer accepted tariff rate change', example: true }),
    tslib_1.__metadata("design:type", Boolean)
], Consents.prototype, "acceptedTariffRateChange", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ description: 'Customer accepted to receive product mail', example: true }),
    tslib_1.__metadata("design:type", Boolean)
], Consents.prototype, "acceptedProductMail", void 0);
